export const categories = [
  {
    slug: "entertainment",
    name: "娱乐八卦",
    short: "圈内动态",
    desc: "聚焦明星日常、恋情绯闻与综艺幕后，第一时间跟进娱乐圈风吹草动。",
    icon: "ri-fire-line",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20red%20carpet%20entrance%20with%20glowing%20spotlights%20and%20blurred%20paparazzi%20silhouettes%2C%20glossy%20magazine%20editorial%20aesthetic%2C%20moody%20cinematic%20lighting%2C%20crimson%20accent%20tones%2C%20high%20detail%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=cat-entertainment&orientation=landscape",
  },
  {
    slug: "celebrity",
    name: "明星黑料",
    short: "深扒内幕",
    desc: "深扒明星不为人知的一面，合约纠纷、资本对赌、行业潜规则全解析。",
    icon: "ri-user-star-line",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20dark%20studio%20portrait%20silhouette%20with%20dramatic%20side%20lighting%20and%20deep%20crimson%20glow%2C%20premium%20entertainment%20news%20editorial%20background%2C%20mysterious%20moody%20atmosphere%2C%20high%20detail%2C%20no%20text%2C%20no%20visible%20faces&width=800&height=600&seq=cat-celebrity&orientation=landscape",
  },
  {
    slug: "society",
    name: "社会热点",
    short: "全网热议",
    desc: "追踪全网热议的社会事件与网络乱象，还原事件背后的完整脉络。",
    icon: "ri-alarm-warning-line",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20night%20city%20skyline%20with%20neon%20warning%20glow%20and%20rain%20slick%20streets%2C%20investigative%20news%20documentary%20aesthetic%2C%20deep%20amber%20and%20crimson%20accents%2C%20moody%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cat-society&orientation=landscape",
  },
  {
    slug: "film",
    name: "影视资讯",
    short: "片场风云",
    desc: "影视项目幕后你来我往，换角、改档、票房争议，一次看个明白。",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20vintage%20film%20set%20with%20cinema%20camera%20and%20dramatic%20warm%20key%20light%2C%20moody%20dark%20production%20studio%20atmosphere%2C%20amber%20and%20crimson%20accents%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cat-film&orientation=landscape",
  },
];